import { render, staticRenderFns } from "./userDashboardNutritionNotes.vue?vue&type=template&id=b2cc0de6"
import script from "./userDashboardNutritionNotes.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports